// i18n area 'cluster' — locale sr-Latn-RS (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Script LATINO (srpska latinica, da ratificare).
// Sidecar anti-stantie: ../meta/cluster.sr-Latn-RS.meta.json.
import type { enUS } from './cluster'

export const srLatnRS: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Garantni pristupi',
      subtitle: 'Servisna vrata čvora: pristup samo za čitanje sa privremenom lozinkom i hitni nalog sa lozinkom iz sefa',
      readOnlyTitle: 'Pristup samo za čitanje (trantor)',
      stateNone: 'zatvoren',
      stateGranted: 'otvoren',
      stateGrantedPending: 'odobren — primenjuje se na čvoru',
      grantedBy: 'Odobrio',
      grantedAt: 'Odobreno',
      expiresAt: 'Ističe',
      reason: 'Razlog',
      endedAt: 'Zatvoren',
      endedReason: {
        revoked: 'opozvan',
        expired: 'istekao (TTL)',
        reboot: 'ponovno pokretanje čvora',
        failed: 'nije primenjen (zadatak nije uspeo)'
      },
      grant: 'Odobri pristup samo za čitanje…',
      grantTitle: 'Odobri pristup samo za čitanje',
      grantSubmit: 'Odobri',
      grantError: 'Odobrenje je odbijeno',
      grantConfirm: 'TVirt generiše privremenu lozinku za sistemskog korisnika «trantor» (samo čitanje: journal i dijagnostika, bez sudo) i postavlja je na čvoru zadatkom. Lozinka se prikazuje SAMO jednom, pri potvrdi; prestaje istekom, opozivom ili pri sledećem ponovnom pokretanju čvora.',
      reasonLabel: 'Razlog',
      reasonHint: 'Zašto otvarate vrata: ostaje u odobrenju, u reviziji i u dnevniku',
      ttlLabel: 'Trajanje',
      ttlHours: '{n} h',
      revoke: 'Opozovi pristup samo za čitanje…',
      revokeTitle: 'Opozovi pristup samo za čitanje',
      revokeSubmit: 'Opozovi',
      revokeError: 'Opoziv je odbijen',
      revokeConfirm: 'Odobrenje prestaje odmah i zadatak ponovo zaključava korisnika «trantor» na čvoru: privremena lozinka prestaje da važi.',
      passwordTitle: 'Lozinka samo za čitanje',
      passwordOnce: 'Ova lozinka se prikazuje SAMO jednom: kopirajte je sada. Nigde se ne čuva i neće moći ponovo da se pročita — ako je izgubite, odobrite ponovo.',
      passwordUser: 'Korisnik',
      passwordLabel: 'Lozinka',
      passwordHint: 'Važi do {until} ili do sledećeg ponovnog pokretanja čvora; upotrebljiva kada je zadatak odobrenja završen. Pristup: ssh trantor@<adresa čvora>.',
      emergencyTitle: 'Poslednji hitni pristup (trantor-emergency)',
      lastLogin: '{time} putem {via} sa {from}',
      lastLoginNone: 'ništa zabeleženo',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konzola',
        sudo: 'sudo',
        unknown: 'nepoznato'
      },
      emergencyHint: 'Hitni nalog «trantor-emergency» (puni sudo) uvek je omogućen sa lozinkom generisanom pri instalaciji čvora i čuvanom u sefu: TVirt je ne zna, ne rotira i ne obnavlja. Svaka prijava se prijavljuje ovde i u dnevniku događaja.'
    },
    nodeFirewall: {
      tab: 'Firewall',
      title: 'Firewall čvorova',
      subtitle: 'Postura nftables ruleseta koji svaki čvor primenjuje na sebe — jedini firewall jednog čvora (firewalld je onemogućen)',
      modeLabel: 'Postura',
      mode: {
        disabled: 'Onemogućen — nema ruleseta na čvorovima',
        permissive: 'Permisivan — broji i beleži, ništa ne odbacuje',
        enforced: 'Primenjen — ulazi samo izvedeni registar'
      },
      hint: {
        disabled: 'Kao danas: čvorovi ne nose nikakav ruleset. Pređite na permisivan da PROČITATE šta bi bilo odbačeno pre nego što bude odbačeno.',
        permissive: 'Svaki čvor primenjuje svoj izvedeni ruleset uz policy accept: ono što bi primenjeni režim odbacio broji se i beleži (journal prefiks «tvirt-node would-drop:»). Ništa se ne blokira.',
        enforced: 'Svaki čvor primenjuje svoj izvedeni ruleset uz policy drop: ssh i API odasvud, store / live migration / overlay / Ceph samo od članova, listeneri mrežnih servisa iz mreže koju opslužuju. Svaka promena je apply uz potvrdu — čvor koji ne uspe da potvrdi sam se vraća nazad.'
      },
      confirmTitle: 'Primeniti firewall čvorova?',
      confirmBody: 'Svaki čvor primenjuje ruleset uz potvrdu: sondira backend, store i ssh kroz nova pravila u roku i potvrđuje — inače se sam vraća na prethodni ruleset. Prvo pročitajte brojače permisivnog režima na čvorovima.',
      confirmSubmit: 'Primeni',
      confirmCancel: 'Otkaži',
      lensTitle: 'Firewall čvora',
      loadError: 'Nije moguće učitati sočivo firewalla čvora',
      noReport: 'Još nema firewall izveštaja sa ovog čvora — worker izveštava pri sledećem prolazu',
      firewalldActive: 'Na ovom čvoru radi firewalld: firewall čvora odbija da se primeni pored njega (maskirajte firewalld)',
      conditionUnconfirmed: 'Još nema potvrđenog ruleseta — čvor je otvoren',
      conditionRolledBack: 'Poslednji apply se vratio nazad — ista generacija se ne pokušava ponovo dok se registar ne promeni ili se postura ponovo ne promeni',
      lastError: 'Poslednja greška',
      posture: 'Postura',
      observedAt: 'Posmatrano',
      desiredGeneration: 'Željena generacija',
      componentTitle: 'Komponenta čvora',
      componentSubtitle: 'tvirt-node-firewall — pri boot-u primenjuje potvrđeni ruleset, nepotvrđeni sam vraća nazad',
      componentAbsent: 'Komponenta još nije izvestila',
      phase: 'Faza',
      phases: {
        none: 'Nikad primenjen',
        applied: 'Primenjen — čeka potvrdu',
        confirmed: 'Potvrđen',
        rolledBack: 'Vraćen nazad'
      },
      generation: 'Generacija',
      appliedAt: 'Primenjeno',
      confirmedAt: 'Potvrđeno',
      deadline: 'Rok za rollback',
      lastRollback: 'Poslednji rollback',
      registryTitle: 'Izvedeni registar',
      registrySubtitle: 'Portovi koje ovaj čvor otvara, po klasi i poreklu — izvedeni iz klastera, nikad ručno menjani',
      registryEmpty: 'Ništa nije izvedeno — postura onemogućena bez potvrđenog ruleseta, ili još nema izveštaja',
      colClass: 'Klasa',
      colPort: 'Port',
      colSource: 'Izvor',
      colOrigin: 'Poreklo',
      classes: {
        public: 'Javna',
        internode: 'Međučvorna',
        tenant: 'Tenant'
      },
      sourceMembers: 'samo članovi',
      sourceAnywhere: 'odasvud',
      sourceBridge: 'na {iface}'
    },
    derivationDerived: 'izveden',
    derivationDiverged: 'odstupljen',
    derivationDerivedTip: 'Mrežni dokument je IZVEDEN iz fabrica {fabric} i još se poklapa sa renderom na trenutnim ulazima — klik za plan derivacije.',
    derivationDivergedTip: 'Derivacija iz fabrica {fabric} promenila se posle zadnjeg apply-a (fabric, ožičenje, uloge ili reference) — klik za čekajući diff.',
    derivationRetiring: {
      one: '{n} adresa se prazni',
      few: '{n} adrese se prazne',
      other: '{n} adresa se prazni'
    },
    standaloneHint: 'Ovaj čvor nema klaster: još nije instaliran. Klasteri se kreiraju ILI im se pristupa pri instalaciji — join token generisan iz tabele Serveri jednog člana daje se installeru (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Vaše dozvole pokrivaju jedan scope, ne ceo klaster: inventar flote — čvorovi, podešavanja i uređaji — vidljiv je samo administratorima klastera.',
    phaseReady: 'Spreman',
    phaseForming: 'U formiranju',
    storeMembers: 'Članovi storea',
    watermark: 'Prag konvergencije',
    configGeneration: 'Config generacija',
    converged: 'usklađeno',
    behind: 'zaostaje — {m} / {n}',
    revision: 'Revizija',
    rolesTitle: 'Mrežne uloge',
    rolesSubtitle: 'Adrese po članu za svaku klasu saobraćaja — sama konektivnost živi u host mreži',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'nasleđuje management',
    settingsTitle: 'Podešavanja',
    settingsSubtitle: 'Bezbednosna policy na nivou klastera — svaki čvor je procenjuje iz svoje lokalne replike',
    taskRetentionTitle: 'Retencija zadataka',
    taskRetentionSubtitle: 'Objedinjeni GC za sve zadatke — završeni zadaci preko starosne granice ili limita se sakupljaju, oni u toku nikada',
    taskRetentionMaxAge: 'Maksimalna starost (dani)',
    taskRetentionMaxCount: 'Maksimalan broj zadataka',
    eventRetentionTitle: 'Zadržavanje događaja',
    eventRetentionSubtitle: 'GC dnevnika — politika nezavisna od one zadataka: zadatak je red, događaj je memorija',
    eventRetentionMaxAge: 'Najveća starost (dani)',
    eventRetentionMaxCount: 'Najveći broj događaja',
    spaceThresholdsTitle: 'Pragovi prostora',
    spaceThresholdsSubtitle: 'Kada skladište koje se puni dospe u dnevnik (i obaveštenja)',
    spaceLowPct: 'Upozorenje od (% iskorišćeno)',
    spaceCriticalPct: 'Kritično od (% iskorišćeno)',
    spaceOrderError: 'Kritično ne može biti ispod upozorenja',
    spaceThresholdsHint: 'Konfigurišu se samo ulazi: izlaz izvodi motor, 5 poena ispod svakog praga, da skladište na liniji nikada ne postane metronom',
    failoverReserveTitle: 'Failover rezerva',
    failoverReserveSubtitle: 'Admission control N+1 — RAM koji se drži slobodnim da bi klaster mogao da restartuje svoje opterećenje posle gubitka čvorova',
    failoverReserveTolerate: 'Broj čvorova čiji se gubitak toleriše',
    failoverReserveOff: '0 — rezerva je isključena: nijedno pokretanje se nikada ne odbija zbog failover kapaciteta',
    failoverReserveOn: 'Pokretanje koje bi načelo rezervu odbija se uz 412 koji objašnjava brojeve',
    networkShapingTitle: 'Pravednost propusnog opsega',
    networkShapingSubtitle: 'Tri tipološke težine shaping stabla po uplink-u — deluju samo pod nadmetanjem',
    networkShapingRest: 'Težina ostatka (upravljačka ravan, storage, replike)',
    networkShapingOverlay: 'Težina overlay mreža',
    networkShapingLiveMigration: 'Težina live migracije',
    networkShapingHint: 'Zagarantovani udeo = težina / zbir tri (podrazumevano 300 / 100 / 200, svaka od 1 do 10000); na slobodnoj vezi svaka klasa može uzeti ceo opseg',
    debugModeTitle: 'Debug režim',
    debugModeSubtitle:
      'Detaljne greške u generičkim upozorenjima GUI-ja — da se vidi pravi uzrok kada je „neuspešna“ akcija zapravo uspela',
    debugModeLabel: 'Debug režim omogućen',
    debugModeOn: 'Generička upozorenja o grešci dodaju na kraj uzrok u pozadini — interni detalji vidljivi svakom operateru',
    debugModeOffHint: 'Isključen — generička upozorenja o grešci ostaju generička, bez internih detalja',
    nodeDetailsAction: 'Detalji čvora',
    node: {
      docTitle: 'Čvor',
      notFound: 'Čvor nije pronađen',
      tabOverview: 'Pregled',
      tabStats: 'Statistika',
      tabNetwork: 'Mreža',
      tabSettings: 'Lokalna podešavanja',
      identityTitle: 'Identitet',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL port',
      revision: 'Config revizija',
      versionsTitle: 'Posmatrane verzije',
      heartbeatSubtitle: 'Poslednje stanje koje je čvor prijavio o sebi',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU model',
      memoryTitle: 'Memorija',
      hugePagesTitle: 'Ogromne stranice',
      hugePagesPool: '{size}: slobodno {free} od {total}',
      hugePagesNone: 'Nema poola',
      hugePagesNoneHint: 'Čvor nema rezervisane ogromne stranice: VM-ovi koji ih traže ne mogu ovde da se pokrenu. Pool se deklariše na čvoru, kernel parametrima hugepagesz i hugepages ili upisom nr_hugepages.',
      usageTitle: 'Trenutna upotreba',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'nije posmatrano — nema svežeg uzorka',
      statsNoData: 'Nema podataka u izabranom opsegu — serije čvora uzorkuje sam čvor i služi ih lokalno.',
      observedTitle: 'Posmatrano stanje',
      observedSubtitle: 'Servisi i aseti lokalni za čvor, kako ih vidi worker'
    },
    editRolesTitle: 'Izmenite mrežne uloge',
    memberNode: 'Čvor',
    memberIp: 'IP adresa',
    addMember: 'Dodaj člana',
    lmInherit: 'Koristi management adrese',
    roleIpHint: 'Dodavanje i uklanjanje članova je slobodno; izmena IP-a postojećeg člana na licu mesta se odbija — tok IP migracije stiže u kasnijoj rundi.',
    roleError: 'Uloge nije moguće ažurirati',
    nodesTitle: 'Čvorovi',
    addNodeTitle: 'Dodajte čvor u klaster',
    addNode: 'Dodaj čvor',
    addNodeError: 'Čvor nije moguće predregistrovati',
    nodeName: 'Ime čvora',
    nodeNameHint: 'mora se poklapati sa imenom izabranim pri instalaciji',
    nodeIp: 'Management IP',
    colName: 'Ime',
    colPhase: 'Faza',
    colServices: 'Servisi',
    colWatermark: 'Watermark',
    colLastSeen: 'Poslednji kontakt',
    colUps: 'UPS',
    upsCordonChip: 'UPS kordon',
    upsCordonTip: 'Čvor se osudio na osnovu činjenica svog UPS-a ({time}): sam uklanja kordon kad mreža postane stabilna, a baterija napunjena',
    upsUnreachable: 'UPS nedostupan',
    upsOnBattery: 'Na bateriji',
    upsOnLine: 'Na mreži',
    upsLowBattery: 'slaba baterija',
    upsNoEstimateChip: 'autonomija nije procenjena',
    upsNoEstimateTip: 'UPS ne objavljuje procenu autonomije: čvor se osuđuje samo LB zastavicom (slaba baterija) UPS-a — podesite battery.runtime.low / LB na samom UPS-u',
    upsLaneTip: 'UPS put gašenja od {since}: osuđen zbog {by}',
    upsUnit: 'jedinica',
    upsStatus: 'NUT stanje',
    upsLoad: 'opterećenje',
    upsOnBatterySince: 'na bateriji od',
    upsOnLineSince: 'na mreži od',
    upsError: 'greška',
    upsObservedAt: 'posmatrano',
    upsNone: 'nijedna UPS jedinica ne opslužuje ovaj čvor',
    upsBy: {
      runtime: 'autonomija ispod praga',
      lowBattery: 'LB zastavica UPS-a',
    },
    upsLane: {
      evacuate: 'evakuacija',
      local: 'gašenje na mestu',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'zaustavljanje gostiju',
      stoppingServices: 'zaustavljanje servisa',
      poweredOff: 'ugašen',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS jedinice i pragovi: čvor osuđen pri autonomiji ≤ prag ili LB zastavici (uvek poštovana), nastavak sa histerezom',
    upsRuntimeThreshold: 'Prag autonomije (s)',
    upsRuntimeThresholdHint: 'Na bateriji, sa procenjenom autonomijom ≤ prag čvor se gasi po redu (podrazumevano 300)',
    upsResumeStable: 'Mreža stabilna tokom (s)',
    upsResumeStableHint: 'Nastavak samo uz neprekinutu mrežu najmanje toliko sekundi (podrazumevano 60)',
    upsResumeCharge: 'Minimalna napunjenost pri nastavku (%)',
    upsResumeChargeHint: 'I baterija napunjena bar do ovog procenta (podrazumevano 25)',
    upsPolicyNote: 'LB zastavica (slaba baterija) UPS-a uvek osuđuje i ne može se isključiti; ne postoji prag na vreme provedeno na bateriji. Svaka jedinica može prepisati ta tri broja.',
    upsUnitNew: 'nova jedinica',
    upsUnitSelectors: '{n} selektor(a) po oznakama (samo CLI)',
    upsUnitName: 'Naziv jedinice',
    upsUnitMode: 'Režim',
    upsModeExternal: 'spoljna (tuđi upsd)',
    upsModeManaged: 'upravljana (UPS povezan na čvor)',
    upsUnitUpsname: 'NUT naziv (upsname)',
    upsUnitHost: 'upsd host',
    upsUnitAttachedNode: 'Povezani čvor',
    upsUnitDriver: 'NUT drajver',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Uređaj drajvera',
    upsUnitDeviceHint: 'red port= u ups.conf: prazno = auto',
    upsUnitPort: 'upsd port',
    upsUnitServedNodes: 'Opsluživani čvorovi',
    upsUnitServedNodesHint: 'nazivi čvorova odvojeni zarezima (selektori po oznakama idu kroz CLI)',
    upsUnitOverrideHint: 'prazno = podrazumevano klastera',
    upsUnitAdd: 'Dodaj jedinicu',
    unreachableSince: 'Nedostupan — poslednji heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Overlay dataplane još nije realizovao tekuću overlay konfiguraciju',
    overlaysError: 'Poslednji prolaz overlay usaglašavanja neuspešan: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Čeka join',
      'joining': 'Pristupa',
      'member': 'Član'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Prikazan samo sada — odmah ga kopirajte, više neće moći da se pročita',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    close: 'Zatvori',
    revokeTitle: 'Opozovite predregistraciju',
    revoke: 'Opozovi',
    revokeError: 'Registraciju nije moguće opozvati',
    promote: 'Unapredi u store member',
    demote: 'Ukloni ulogu store-member',
    troubleshoot: 'Rešavanje problema',
    promoteTitle: 'Unapredite u store member',
    demoteTitle: 'Uklonite ulogu store-member',
    promoteHint: 'Čvor ulazi u kvorum YugabyteDB mastera. Prava HA zahteva tri store membera.',
    demoteHint: 'Čvor izlazi iz kvoruma mastera i zaustavlja svoje store servise.',
    storeError: 'Izmena store-membera je odbijena',
    attest: 'Atestiraj kao ugašen…',
    attestTitle: 'Atestirajte čvor kao ugašen',
    attestSubmit: 'Atestiraj kao ugašen',
    attestConfirm: 'Proglašavate ovaj čvor ugašenim, na sopstveni rizik: atestirati čvor koji je u stvari živ rizikuje dvostruko izvršavanje VM-ova. Njegovi zadaci se obeležavaju kao neuspešni, a authority njegovih VM-ova postaju prenosivi.',
    attestError: 'Atestacija je odbijena',
    attestedChip: 'atestiran kao ugašen',
    maintenanceChip: 'održavanje',
    guestToolsChip: 'TVirt Guest Tools (ISO aset lokalan za čvor)',
    maintenanceEnter: 'Uključi održavanje',
    maintenanceExit: 'Isključi održavanje',
    maintenanceEnterTitle: 'Uključite održavanje',
    maintenanceExitTitle: 'Isključite održavanje',
    maintenanceEnterSubmit: 'Uključi održavanje',
    maintenanceExitSubmit: 'Isključi održavanje',
    maintenanceEnterConfirm: 'Čvor se stavlja u kordon i prazni: mrežne usluge i App instance čiji authority drži prenose se (instance na hladno: zaustavljene i požnjevene ovde, ponovo stvorene na odredišnom čvoru — prekid), pokrenute VM migriraju se uživo gde je moguće, inače se uredno zaustavljaju, zadaci u toku se završavaju, novi posao čeka, a zaustavljene VM gube svoj authority — Proximity ih ponovo smešta pri sledećem pokretanju. Ništa se ne vraća samo na kraju održavanja.',
    maintenanceExitConfirm: 'Čvor ponovo preuzima posao i Proximity ga opet uzima u obzir za raspoređivanje. VM-ovi se vraćaju samo kada se pokrenu.',
    maintenanceError: 'Zahtev za održavanje je odbijen',
    maintenancePlanTitle: 'Plan evakuacije',
    maintenancePlanLoading: 'Izračunavanje plana evakuacije…',
    maintenancePlanError: 'Plan evakuacije nije moguće učitati — drain će svejedno migrirati gde je moguće i zaustaviti ostalo.',
    maintenancePlanEmpty: 'Na ovom čvoru nema šta da se evakuiše — nema aktivne mrežne usluge, nema App instance koja se želi pokrenuta, nema pokrenute VM.',
    maintenancePlanSummary: '{migrate} objekata će migrirati (VM, mrežne usluge, App instance), {stop} će se zaustaviti ili ostati gde jesu.',
    maintenancePlanReserve_ok: 'Failover rezerva posle pražnjenja: netaknuta — ostaje {headroom} GiB za pokretanje dok se toleriše gubitak čvorova: {n}.',
    maintenancePlanReserve_eroded: 'Failover rezerva posle pražnjenja: skoro potrošena — ostaje samo {headroom} GiB od {reserve} GiB koji se drže slobodnim za otkaze čvorova: {n}.',
    maintenancePlanReserve_exhausted: 'Failover rezerva posle pražnjenja: ISCRPLJENA — nedostaje {headroom} GiB od {reserve} GiB potrebnih da se tolerišu otkazi čvorova: {n}. Dok je ovaj čvor van, nova pokretanja VM-ova biće odbijana.',
    maintenancePlanReserve_unknown: 'Failover rezerva posle pražnjenja: ne može se izračunati — nijedan preostali čvor nije prijavio svoju memoriju.',
    maintenancePlanReserveHugePages: 'Ogromne stranice od {size} posle pražnjenja — slobodno: {free} od {capacity}, potrebno kao rezerva: {reserve}.',
    maintenancePlanActionMigrate: 'migrira',
    maintenancePlanActionMigrateWarning: 'migrira (soft pravilo prekršeno)',
    maintenancePlanActionStop: 'zaustavlja se',
    maintenancePlanActionBlocked: 'blokiran',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'mrežna usluga',
    maintenancePlanKindApp: 'App instanca',
    maintenancePlanColdMove: 'Premeštanje na hladno: pod se ovde zaustavlja i žanje, a odredišni worker ga ponovo stvara — prekid do sledećeg pass-a odredišnog worker-a.',
    caFingerprint: 'Fingerprint CA klastera',
    staleChip: 'zastarelo',
    troubleshootTitle: 'Rešavanje problema sa storeom',
    restartStore: 'Restartuj store servise',
    restartHint: 'Ako se store ponaša čudno, restartujte njegove servise. Napredno — koristiti oprezno.',
    restartQueued: 'Zadatak restartovanja u redu čekanja',
    restartError: 'Servise nije moguće restartovati',
    svcActive: 'aktivan',
    svcWanted: 'željen, nije aktivan',
    svcStopped: 'zaustavljen',
    noServices: 'Nijedan servis nije prijavljen'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'GPU inventar celog klastera grupisan po modelu — posmatrane kartice po čvoru, sa markiranim registracijama i njihovim tagovima',
    usbTitle: 'USB resursi',
    usbSubtitle: 'USB inventar celog klastera grupisan po modelu — posmatrani uređaji po čvoru, sa registracijama oba modela (po uređaju, po portu) i njihovim tagovima',
    markedChip: 'upotrebljivih za TVirt: {n}',
    orphanChipGpu: 'napuštenih: {n}',
    orphanChipUsb: 'napuštenih: {n}',
    colNode: 'Čvor',
    colRegistration: 'Registracija',
    noRegsHint: 'Nema registracija — uređaj se markira kao „upotrebljiv za TVirt“ iz dijaloga čvora (Čvorovi › čvor › Podešavanja).',
    colDevice: 'Uređaj',
    colObserved: 'Posmatrani',
    colRegs: 'Registracije',
    regsNone: 'nijedna',
    colPci: 'PCIe adresa',
    colIdentity: 'Identitet / port',
    colClasses: 'Klase (tagovi)',
    colActions: 'Akcije',
    manageOnNode: 'Upravljaj na čvoru {node} (markiranje živi u dijalogu čvora)',
    introTitle: 'Klasterski inventar USB i PCIe uređaja upotrebljivih za TVirt©.',
    introStep1: '1. Čvorovi sami otkrivaju svoje GPU-ove i USB uređaje (popis u heartbeatu).',
    introStep2: '2. Uređaj se markira kao „upotrebljiv za TVirt“ iz dijaloga ČVORA (Čvorovi › čvor › Podešavanja) — markiranje ga vezuje za vfio i registruje ga ovde.',
    introStep3: '3. Ovde registracijama dajete njihove KLASE preko tagova (npr. gpu_class=compute): zahtevi VM-ova tražiće klasu, a scheduler će izabrati čvor sa slobodnim odgovarajućim uređajem.',
    colMode: 'Režim',
    colState: 'Stanje',
    colNotes: 'Beleške',
    colTags: 'Tagovi',
    modeDevice: 'po uređaju',
    modePort: 'po portu',
    usable: 'upotrebljiv',
    orphanGpu: 'napuštena',
    orphanUsb: 'napušten',
    hubChip: 'hub',
    orphanPortsTitle: 'Registracije po portu bez prikačenog uređaja — ponovo prikačite uređaj ili im na čvoru poništite markiranje',
    gpusEmpty: 'Nijedan GPU još nije posmatran ni na jednom čvoru',
    usbEmpty: 'Nijedan USB uređaj još nije posmatran ni na jednom čvoru'
  },

  // Vocabolario condiviso dei form impostazioni (refactoring 2026-07-24): i campi
  // security alimentano la card della pagina Cluster, i campi nodo la pagina
  // node-settings — la pagina /system/settings per cui nacquero è morta.
  settings: {
    passwordMinLength: 'Minimalna dužina lozinke',
    sessionIdle: 'Timeout neaktivnosti sesije (minuti)',
    lockoutThreshold: 'Zaključavanje posle neuspešnih pokušaja',
    lockoutDuration: 'Trajanje zaključavanja (minuti)',
    keyboardLayout: 'Raspored tastature',
    keyboardLayoutHint: 'npr. it, en-us — prazno za podrazumevani QEMU',
    syslogEndpoint: 'Syslog endpoint',
    syslogEndpointHint: 'host:port — prazno da se prosleđivanje onemogući',
    syslogTls: 'TLS',
    maxQueued: 'Maksimum zadataka u redu čekanja',
    concurrency: 'Konkurentnost workera',
    concurrencyHint: 'Worker je primenjuje u hodu',
    notesTitle: 'Beleške',
    save: 'Sačuvaj',
    saved: 'Podešavanja sačuvana',
    saveError: 'Podešavanja nije moguće sačuvati'
  },
  localSettings: {
    derivedChip: 'izveden',
    derivedTip: 'Ovaj device je u VLASNIŠTVU derivacije fabrica (H2): editor odbija da ga dira — izmenite fabric (ili ožičenje) i ponovo primenite, ili ga uzmite nazad ispod.',
    takeOwnership: 'Preuzmi vlasništvo',
    takeOwnershipTitle: 'Preuzmi vlasništvo (take-ownership)',
    takeOwnershipConfirm: '{name} napušta fabric blok i ponovo postaje RUČNI device kojim upravlja ovaj editor. Čvor postaje odstupljen, a sledeći apply derivacije na njemu će odbiti (manualConflict) dok ga ne preimenujete ili uklonite — ili ne ispravite fabric.',
    nodeSettingsTitle: 'Podešavanja čvora',
    nodeSettingsSubtitle: 'Ono što ovaj čvor sprovodi — red zadataka, konzola, prosleđivanje logova — plus njegovi tagovi i beleške',
    baseTitle: 'Host rezerve (TVirt Proximity)',
    baseSubtitle: 'CPU i RAM rezervisani za operativni sistem hosta — ulazi empirijskog kapaciteta po kom Proximity raspoređuje VM-ove',
    baseMemory: 'Bazni RAM (MiB)',
    baseMemoryHint: 'Posmatrano ukupno: {total} MiB. Upotrebljivo za VM-ove = ukupno − baza − RAM upaljenih VM-ova raspoređenih ovde.',
    baseMemoryHintNoTotal: 'Upotrebljivo za VM-ove = posmatrano ukupno − baza − RAM upaljenih VM-ova raspoređenih ovde.',
    baseCpu: 'Bazna CPU jezgra',
    baseCpuHint: 'Posmatrani logički CPU-ovi: {total}. Koristi se samo kao težina za rangiranje — vCPU overcommit je normalan.',
    baseCpuHintNoTotal: 'Koristi se samo kao težina za rangiranje — vCPU overcommit je normalan.',
    baseHint: 'RAM je tvrda kapija prijema: VM koji ne staje u upotrebljivi RAM odbija se uz rečitu grešku. Povećajte bazu na hostovima koji drže članove storea ili Ceph demone.',
    placementTitle: 'Fizički smeštaj',
    placementSubtitle: 'Gde ovaj server fizički stoji — deklarisano jednom, čemu god služio',
    placementHint: 'Smeštaj vodi CRUSH hijerarhiju svakog Ceph klastera sa OSD-om na ovom serveru: čuvanje izmene ponovo poravnava njihove mape kroz zadatak (host → rack → … → root). Delimične deklaracije su legalne — prazni nivoi se prosto urušavaju. Imena su deljena preko cele mape: dva servera u istom racku deklarišu isto ime racka.',
    placementNameInvalid: 'DNS-safe ime (mala slova, cifre, crtice)',
    placementEmpty: 'Prazno = nije deklarisano',
    placementLevel: {
      chassis: 'Šasija',
      rack: 'Rack',
      row: 'Red',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Prostorija',
      datacenter: 'Datacenter',
      zone: 'Zona',
      region: 'Region'
    },
    cablingTitle: 'Kabliranje',
    cablingSubtitle: 'U koji switch port je utaknut svaki interfejs — deklaracija živi na čvoru (Annex O.9)',
    cablingHint: 'Jedan kabl po NIC-u, jedan kabl po portu na celoj floti (API odbija imenujući nosioca). Kabliranje ka portu koji je član LAGG-a je legalno — to je bond slučaj: buduća derivacija će ga izvesti kao LACP.',
    cablingInterface: 'Interfejs',
    cablingNotCabled: '— nije kablirano —',
    cablingNoInterfaces: 'Nijedan mrežni interfejs još nije posmatran',
    disksTitle: 'Diskovi',
    disksSubtitle: 'Posmatrani blok uređaji — jedno skeniranje po prolazu usaglašavanja; ovde markirajte diskove upotrebljive kao Ceph OSD-ovi (N.15: podobnost je eksplicitna)',
    colDataDisk: 'Disk za podatke',
    dataDisksHint: 'Štikliranje uređaja deklariše ga kao upotrebljivog za OSD; serijski broj je njegov identitetski pin — kopiran iz hardvera kada ga disk prijavi, iskovan (tvirt-…) u suprotnom. Ceph dijalog za registraciju nudi samo deklarisane diskove.',
    diskDeclaredSerial: 'deklarisan',
    diskNotObserved: 'deklarisan, ali nije posmatran — ponovo prikačite uređaj ili uklonite štiklu',
    noDisks: 'Nijedan blok uređaj još nije posmatran',
    colSerial: 'Serijski broj',
    colModel: 'Model',
    colSize: 'Veličina (GiB)',
    colDiskType: 'Tip',
    colInUse: 'U upotrebi',
    colObservedAt: 'Posmatran',
    diskInUse: 'u upotrebi',
    diskFree: 'slobodan',
    diskMounted: 'montiran',
    diskPartitions: 'particije',
    passthroughTitle: 'Passthrough uređaji',
    passthroughSubtitle: 'Posmatrani GPU-ovi i USB uređaji — ovde markirajte šta TVirt sme da prosledi VM-ovima; markiranje registruje identitet uređaja (round U1+G1)',
    passthroughHint: 'Markiranje registruje uređaj (stabilan id — meta tagova i klasnih zahteva). Markirani GPU ima CELU IOMMU grupu vezanu za vfio-pci odjednom — odmah napušta host; poništavanje markiranja ponovo vezuje nativni driver. Za USB postoje oba ratifikovana modela: po uređaju (vendor+proizvod, gde god da je prikačen) i po fizičkom portu (VM dobija šta god je tu utaknuto). USB se ne vezuje pri markiranju — attach se dešava u runtimeu VM-a.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Upotrebljiv za TVirt',
    colGpu: 'GPU',
    colPciAddress: 'PCI adresa',
    colDriver: 'Driver',
    colVerdict: 'Verdikt',
    gpuEligible: 'Podoban',
    gpuIneligible: 'Nepodoban',
    gpuReason: {
      'no-iommu': 'IOMMU nije aktivan na hostu',
      'group-spans-slots': 'IOMMU grupa nije izolovana: prostire se preko drugih slotova',
      'multiple-display': 'IOMMU grupa nije izolovana: više od jedne video funkcije',
      'foreign-function': 'IOMMU grupa nije izolovana: sadrži stranu funkciju'
    },
    vfioNotReady: 'IOMMU nije aktivan na ovom hostu: nijedan GPU nije podoban dok ga host platforma ne omogući (OEM ISO) — TVirt nikada ne dira kernel args u runtimeu.',
    vfioMissingKernelArg: 'IOMMU nije aktivan na ovom hostu: firmware prijavljuje VT-d/AMD-Vi (ACPI DMAR/IVRS tabela postoji), ali nedostaje kernel arg — dodajte intel_iommu=on (Intel) ili uklonite amd_iommu=off (AMD) sa kernel komandne linije i restartujte. TVirt nikada ne dira kernel args u runtimeu.',
    vfioFirmwareDisabled: 'IOMMU nije aktivan na ovom hostu: VT-d/AMD-Vi je onemogućen u firmwareu (nema ACPI DMAR/IVRS tabele) ili ga CPU ne podržava — omogućite ga u firmware podešavanjima, nijedan kernel arg ne može da ga uključi. TVirt nikada ne dira host u runtimeu.',
    gpuBindError: 'vfio-pci bind neuspešan na {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Firewall na neupravljanim bridgeovima',
    firewallBridgesSubtitle: 'Ručno izgrađeni bridgeovi na ovom čvoru čiji setup pristaje na firewall chainove koje TVirt renderuje na prikačenim guest NIC-ovima',
    firewallBridgesHint: 'TVirt nikada ne dira tuđi bridge — chain se sidri na tap/veth, koji je uvek TVirtov. Lista je kapija pristanka: default-deny i anti-spoof mogu da slome ono što ručni setup očekuje, pa se NIC sa firewallom na neupravljanom bridgeu koji NIJE ovde naveden odbija uz rečitu grešku.',
    firewallBridgesEmpty: 'Nijedan neupravljani bridge na ovom čvoru ne pristaje na firewall chainove koje TVirt renderuje.',
    firewallBridgeAdd: 'Dodaj bridge',
    firewallBridgeInvalid: 'Nije ime Linux interfejsa (1-15 znakova, bez kose crte i razmaka)',
    firewallBridgeDuplicate: 'Ime je već na spisku',
    colMarkDevice: 'Po uređaju',
    colMarkPort: 'Po portu',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'napušten — registrovan, ali se više ne detektuje: ponovo ga prikačite ili mu poništite markiranje',
    noGpus: 'Nijedan GPU još nije posmatran',
    noUsb: 'Nijedan USB uređaj još nije posmatran',
    networkGeneration: 'Mrežna generacija',
    applied: 'Primenjena',
    converged: 'usklađeno',
    behind: 'zaostaje — {m} / {n}',
    notConfigured: 'nije konfigurisano',
    rollbackBody: 'Primena generacije {gen} neuspešna: {error}',
    rolledBackChip: 'rollback izvršen',
    nicsTitle: 'NIC-ovi',
    nicsSubtitle: 'Matični podaci upravljanih NIC-ova — registracija JESTE deklaracija upravljanja: registrovani NIC bez konfiguracije se ne dira (clear-if ga eksplicitno deklariše čistim), neregistrovan uređaj se nikada ne dira',
    addNic: 'Registruj NIC',
    addNicTitle: 'Registrujte NIC (add-nic)',
    delNic: 'Okončaj upravljanje',
    delNicTitle: 'Okončajte upravljanje (del-nic)',
    delNicConfirm: 'Upravljanje uređajem {name} se okončava: stavka matičnih podataka i njena konfiguracija se brišu, a TVirt profil se uklanja — sam uređaj ostaje onakav kakvim ga Linux drži.',
    nicName: 'Ime uređaja',
    nicMac: 'Trajna MAC adresa',
    nicMacHint: 'trajni hardverski MAC — stabilni identitet koji postavlja TVirt Server Installer',
    colObserved: 'Posmatran',
    nicObserved: 'posmatran',
    nicNotObserved: 'nije posmatran',
    nicMacMismatch: 'MAC se ne poklapa — posmatran {mac}',
    noNics: 'Nijedan NIC nije registrovan — registrujte uređaj da biste počeli da njime upravljate',
    noManagedDevices: 'Nema upravljanih uređaja — najpre registrujte NIC, sve se gradi na matičnim podacima',
    inventoryTitle: 'Posmatrani uređaji',
    inventorySubtitle: 'Osvežava ih worker čvora pri svakom prolazu usaglašavanja — validacija proverava imena uređaja u odnosu na ovaj inventar',
    colDevice: 'Uređaj',
    colType: 'Tip',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Brzina',
    colTopology: 'Topologija',
    colMtu: 'MTU',
    colAddresses: 'Adrese',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP ne agregira',
    noInventory: 'Do sada nije prijavljen nijedan uređaj',
    interfacesTitle: 'Interfejsi',
    interfacesSubtitle: 'L3 konfiguracija registrovanih NIC-ova i deklarisanih logičkih uređaja — set-if zamenjuje ceo blok, edit-if krpi svojstva, clear-if ga prazni (eksplicitno čišćenje)',
    colConfig: 'Željena konfiguracija',
    clean: 'čist',
    setIf: 'Izmeni adresiranje',
    setIfTitle: 'Izmenite adresiranje (set-if)',
    editIf: 'Izmeni svojstva',
    editIfTitle: 'Izmenite svojstva (edit-if)',
    clearIf: 'Isprazni konfiguraciju',
    clearIfTitle: 'Ispraznite konfiguraciju (clear-if)',
    clearIfConfirm: 'Konfiguracija interfejsa se prazni. Čist interfejs je preduslov da bi se podredio kao član bonda/bridgea ili VLAN parent.',
    ip4Mode: 'IPv4 režim',
    ip6Mode: 'IPv6 režim',
    modeUnconfigured: 'Nekonfigurisan',
    modeStatic: 'Statički',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4 adrese',
    ip6Addresses: 'IPv6 adrese',
    addressesHint: 'CIDR, odvojeno zarezom',
    gw4: 'IPv4 gateway',
    gw6: 'IPv6 gateway',
    dns: 'DNS serveri',
    dnsHint: 'odvojeno zarezom — prazno briše DNS (set-if zamenjuje blok)',
    routes4: 'IPv4 statičke rute',
    routes6: 'IPv6 statičke rute',
    routeTo: 'Odredište (CIDR)',
    routeVia: 'Preko',
    addRoute: 'Dodaj rutu',
    routesChip: 'rute',
    mtu: 'MTU',
    mtuHint: 'prazno = podrazumevano za driver',
    vlansTitle: 'VLAN-ovi',
    addVlan: 'Dodaj VLAN',
    addVlanTitle: 'Dodajte VLAN (add-vlan)',
    delVlanTitle: 'Obrišite VLAN (del-vlan)',
    vlanParent: 'Parent interfejs',
    vlanId: 'VLAN ID',
    vlanPreview: 'Ime uređaja',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Nijedan VLAN nije deklarisan',
    bondsTitle: 'Bondovi',
    addBond: 'Dodaj bond',
    addBondTitle: 'Dodajte bond (add-bond)',
    editBondTitle: 'Izmenite bond',
    editBond: 'Sačuvaj bond',
    delBondTitle: 'Obrišite bond (del-bond)',
    bondName: 'Ime bonda',
    members: 'Članovi',
    membersHint: 'članovi moraju biti čisti interfejsi (bez L3 konfiguracije)',
    bondMode: 'Režim',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Primarni član',
    rate: 'LACP rate',
    hash: 'Politika hasha pri slanju',
    colMembers: 'Članovi',
    colMode: 'Režim',
    noBonds: 'Nijedan bond nije deklarisan',
    bridgesTitle: 'Bridgeovi',
    addBridge: 'Dodaj bridge',
    addBridgeTitle: 'Dodajte bridge (add-bridge)',
    editBridgeTitle: 'Izmenite bridge',
    editBridge: 'Sačuvaj bridge',
    delBridgeTitle: 'Obrišite bridge (del-bridge)',
    bridgeName: 'Ime bridgea',
    stp: 'STP',
    stpOn: 'STP uključen',
    stpOff: 'STP isključen',
    colStp: 'STP',
    noBridges: 'Nijedan bridge nije deklarisan',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Postavi hostname',
    setHostnameTitle: 'Postavite hostname (set-hostname)',
    hostnameHint: 'Samo identitet OS-a — ime čvora u klasteru se ne dira',
    notSet: 'nije postavljen',
    staticHostsTitle: 'Statičke host stavke',
    addStaticHost: 'Dodaj stavku',
    addStaticHostTitle: 'Dodajte statičku host stavku',
    delStaticHostTitle: 'Obrišite statičku host stavku',
    hostIp: 'IP adresa',
    hostNames: 'Imena',
    hostNamesHint: 'odvojeno zarezom ili razmakom',
    colIp: 'IP',
    colNames: 'Imena',
    noStaticHosts: 'Nema statičkih host stavki',
    delConfirm: 'Uklanjanje {name} iz željenog dokumenta — worker čvora konvergira uz NetworkManager checkpoint i automatski rollback.',
    remove: 'Ukloni',
    opError: 'Mrežna operacija je odbijena'
  }
}
